export default __webpack_public_path__ + "static/media/pizza4.9997f308.webp";